import React, { createContext, useContext, useMemo, useCallback, useReducer, FC } from 'react';
import { noop } from 'lodash';
import { IUser } from '../types/IUser';
import { IBaseLayoutProps } from '../types/IBaseLayoutProps';

type TUserState = IUser | null;

export interface IUserState {
    userState: TUserState;
    updateUser: (challenge: IUser) => void;
}

interface IUserAction {
    type: string;
    payload: null | IUser;
}

export const UserContext = createContext<IUserState>({
    userState: null,
    updateUser: noop,
});

export function useUserContext() {
    return useContext(UserContext);
}

const UPDATE_USER = 'UPDATE_USER';

function userReducer(state: TUserState, action: IUserAction): TUserState {
    switch (action.type) {
        case UPDATE_USER:
            return action.payload;
        default:
            return state;
    }
}

export const UserContextProvider: FC<IBaseLayoutProps> = (props) => {
    const { children } = props;
    const [userState, dispatch] = useReducer(userReducer, null);

    const updateUser = useCallback((payload: TUserState) => dispatch({ type: UPDATE_USER, payload }), [dispatch]);

    const value = useMemo(() => ({ userState, updateUser }), [userState, updateUser]);
    return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
